export default __webpack_public_path__ + "c420e56e38817389d83779ec7860105f.png";